// extracted by mini-css-extract-plugin
export default {"badge":"HeaderBadge_badge__nwFeW","green":"HeaderBadge_green__BRs43","orange":"HeaderBadge_orange__qivnw","blue":"HeaderBadge_blue__m1yf+","red":"HeaderBadge_red__n1+Gk"};